import { RouteConfig } from 'vue-router';

// Tech App Users components
const TechAppUsersIndex = () => import(/* webpackChunkName: "tech-app-users-group" */ '@/pages/tech-app-users/TechAppUsersIndex.vue')
const TechAppUsersListHandler = () => import(/* webpackChunkName: "tech-app-users-group" */ '@/pages/tech-app-users/TechAppUsersListHandler.vue')
const SlidePage = () => import('@/pages/SlidePage.vue')
const UnderConstruction = () => import(/* webpackChunkName: "generic-pages-group" */'@/pages/UnderConstruction.vue');

const routes: RouteConfig = {
  path: '/tech-app-users',
  component: SlidePage,
  redirect: '/tech-app-users/',
  children: [
    {
      path: '/',
      component: TechAppUsersIndex,
      name: 'TechAppUsers',
      children: [{
        path: '/',
        component: TechAppUsersListHandler,
        name: "Tech App Users"
      }]
    },
    {
      path: '*',
      name: 'Tech App Users catch all',
      component: UnderConstruction
    }
  ]
};

export default routes;
